import { Navigate } from 'react-router-dom';
import { useUser } from '../providers/user-provider';
import { ROUTES } from './routes';

interface AuthProps {
  children: React.ReactNode;
  isAuthenticated: boolean;
  requiresVerification?: boolean;
}

export function PrivateRoute({ children, isAuthenticated, requiresVerification = true }: AuthProps) {
  const { user } = useUser();
  
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  
  // If verification is required but user is not verified, redirect to check email page
  if (requiresVerification && user && !user.isEmailVerified) {
    return <Navigate to={ROUTES.CHECK_EMAIL.path} replace />;
  }

  // If we are on the check email page (implicit by requiresVerification=false) but user IS verified, redirect to dashboard
  // Note: Since CHECK_EMAIL is now a public route (see router.tsx), this check might be moved there or handled inside the page if desired.
  // But PrivateRoute is no longer wrapping CHECK_EMAIL, so this block effectively only applies to OTHER routes where requiresVerification=false (like what?)

  return <>{children}</>;
}

interface RoleProps extends AuthProps {
  userRoles?: string[];
  allowedRoles: string[];
}
export function RoleGuard({ children, isAuthenticated, userRoles = [], allowedRoles }: RoleProps) {
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!allowedRoles.some(role => userRoles.includes(role)))
    return <Navigate to="/" replace />;
  return <>{children}</>;
}

export function PublicRoute({ children, isAuthenticated }: { children: React.ReactNode, isAuthenticated: boolean }) {
  return isAuthenticated ? <Navigate to="/dashboard" replace /> : <>{children}</>;
}